import React, { useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import "./index.scss";
import { SocketContext } from "../../../context/actions/socket";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { Button } from "reactstrap";
import { forgotPassword } from "../../../context/actions/user";
import { useState } from "react";

const LinkInvalid = ({ className }) => {
  const [disabled, setDisabled] = useState(false)
  const location = useLocation();
  const { backendSocket } = useContext(SocketContext);
  const dispatch = useDispatch();
  const history = useHistory();
  const userDetail = useSelector((state) => state?.user?.user);

  useEffect(() => {
    backendSocket.off("isSubadminLogout").on("isSubadminLogout", (res, err) => {
      if (res) {
        if (res.data && res.data === userDetail._id) {
          console.log(res.role, userDetail.role);
          if (
            res.organization !== userDetail.organization ||
            res.role !== userDetail.role
          ) {
            dispatch({ type: "ISLOADING", data: false });
            dispatch({ type: "LOGOUT", data: {} });
            dispatch({ type: "SET_TEMPDATA", data: {} });
            history.push("/login");
          }
        }
      }
    });
  }, []);

  const resendEmail = (data) =>{
    setDisabled(true);
    if(data.email){
      dispatch(
        forgotPassword(data, (result) => {
          setDisabled(false);
          if(result){
            history.push('/login')
          }
        })
      );
    }
  }

  return (
    <div
      className={`not-found d-flex flex-column flex-fill align-items-center justify-content-center ${className}`}
    >
      <div className="inner">
        {/* <h2>410</h2> */}
        <h3>Link Expired!</h3>
        {location?.state?.email ? <p>Oops! This Password Reset Link is No Longer Valid.</p> : <p>Oops! The Link is No Longer Valid.</p>}
        {location?.state?.email ? (
          <Button disabled= {disabled} className="btn btn-primary" onClick={()=>{resendEmail({email : location?.state?.email})}}>
            Resend Reset Password Email
          </Button>
        ) : (
          <Link to="/" className="btn btn-primary">
            Back to home
          </Link>
        )}
      </div>
    </div>
  );
};

export default LinkInvalid;
